import VueRouterMultiguard from 'vue-router-multiguard';

import SupportExternalConversation from '@/pages/SupportExternalConversation.vue';
import SupportCommunicationsHeader from '@/components/global/header/SupportCommunicationsHeader.vue';
import { AuthMiddleware, PermissionMiddleware } from '@/router/middlewares';
import { ADMIN_PERMISSIONS } from '@/access/adminAccess';

export default {
  path: '/communications/external/:id',
  name: 'communications.external',
  components: {
    default: SupportExternalConversation,
    header: SupportCommunicationsHeader,
  },
  beforeEnter: VueRouterMultiguard([
    AuthMiddleware,
    PermissionMiddleware(ADMIN_PERMISSIONS.COMMUNICATIONS),
  ]),
};
